import React, { useState } from 'react';
import variablesDomain from '../../helpers/variablesDomain';

export default function ModalDescripcionReject(props) {
    const [description, setDescription] = useState('');

    const handleSubmit = () => {
        props.onSubmit(description);
        props.setShowModal(false);
    };

    return (
        <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative w-pop-up my-6 mx-auto max-w-md">
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <button
                            className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                            onClick={() => props.setShowModal(false)}
                        >
                            <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                ×
                            </span>
                        </button>
                        <div className="relative px-6 pb-1 flex-auto">
                            <h3 className="text-3xl font-bold text-trixel-popup centrar-contenido">
                                Rechazar Retiros
                            </h3>
                            <hr />
                            <div className="my-4 py-2 mb-1 text-lg leading-relaxed border-solid text-gray-700 rounded">
                                <div className="flex flex-col px-1 leading-7 margin-10px">
                                    <label className="rounded-full mr-4 text-sm text-left mb-2">
                                        Descripción del rechazo
                                    </label>
                                    <textarea
                                        className="w-full p-2 border rounded-lg"
                                        rows="4"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        placeholder="Ingrese la razón del rechazo..."
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center justify-end p-4 border-gray-300 rounded-b">
                            <button
                                className="bg-red-500 text-white font-bold py-2 px-4 rounded-full mr-2"
                                onClick={() => props.setShowModal(false)}
                            >
                                Cancelar
                            </button>
                            <button
                                className={`bg-${variablesDomain.classNameColor} text-white font-bold py-2 px-4 rounded-full`}
                                onClick={handleSubmit}
                                disabled={!description.trim()}
                            >
                                Rechazar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="fixed inset-0 z-40" style={{
                background: 'rgba(47, 46, 44, 0.5)',
                backdropFilter: 'blur(10px)',
            }}></div>
        </>
    );
} 